import LeaderboardRoundedIcon from '@mui/icons-material/LeaderboardRounded';

export default LeaderboardRoundedIcon;
